import FirebaseContext, { withFirebase, useFirebase } from './context.jsx';
import Firebase from './firebase.js';

export default Firebase;

export { FirebaseContext, withFirebase, useFirebase };
